import { useState, type FormEvent } from 'react';
import { ApiError, guardarSesion, guardarToken, post } from '../api';
import type { Sesion } from '../tipos';

export function Entrada({ onEntrar, admin }: { onEntrar: (s: Sesion) => void; admin?: boolean }): JSX.Element {
  const [usuario, setUsuario] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pista, setPista] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: FormEvent): Promise<void> {
    e.preventDefault();
    setEnviando(true);
    setError(null);
    setPista(null);
    try {
      // Las dos puertas piden usuario y contraseña. El panel también: una
      // contraseña compartida sin usuario haría que el registro de auditoría
      // dijera «admin» hiciera lo que hiciera cualquiera.
      const ruta = admin ? '/admin/login' : '/login';
      const r = await post<{ token: string; session: Sesion }>(ruta, {
        username: usuario,
        password: clave,
      });
      guardarToken(r.token);
      guardarSesion(r.session);
      onEntrar(r.session);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'No se ha podido entrar');
      setPista(err instanceof ApiError ? err.hint : null);
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="entrada">
      <form onSubmit={(e) => void enviar(e)}>
        <div>
          <h1>MRP · ECINSA</h1>
          <p className="sutil" style={{ margin: '4px 0 8px' }}>
            {admin ? 'Panel de administración' : 'Planificación de necesidades de material'}
          </p>
        </div>

        <label className="campo">
          Usuario
          <input value={usuario} onChange={(e) => setUsuario(e.target.value)} autoFocus autoComplete="username" />
        </label>
        <label className="campo">
          Contraseña
          <input
            type="password"
            value={clave}
            onChange={(e) => setClave(e.target.value)}
            autoComplete="current-password"
          />
        </label>

        {error ? (
          <div className="aviso-caja error">
            <div className="titulo">{error}</div>
            {pista ? <div className="sutil">{pista}</div> : null}
          </div>
        ) : null}

        <button className="primario" disabled={enviando}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
